import datapoints from '../../datapoints';
import { getStore as getSharedFavoritesStore, updateFavoritesUserOption } from 'owa-favorites';
import { ActionSource } from 'owa-mail-store';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';

/**
 * Remove a favorite search to the favorite store
 */
export default createLegacyActionWithDatapoint(
    'RemoveFavoriteSearch',
    datapoints.RemoveFavoriteSearch
)(function removeFavoriteSearch(searchQuery: string, actionSource: ActionSource) {
    const sharedFavoritesStore = getSharedFavoritesStore();

    // Check if favoriteSearches doesn't contain the search query
    if (!sharedFavoritesStore.favoriteSearches.has(searchQuery)) {
        throw new Error('Cannot find the search query in favorite search list.');
    }

    // Remove favorite from the store
    sharedFavoritesStore.orderedFavoritesNodeIds.splice(
        sharedFavoritesStore.orderedFavoritesNodeIds.indexOf(searchQuery),
        1
    );
    sharedFavoritesStore.favoriteSearches.delete(searchQuery);

    // Update user options service which is used by OWA
    updateFavoritesUserOption();
});
